// BILDER – Echte Kundenfotos liegen unter /public/images/.
// Küche & Badezimmer: noch keine Kundenfotos vorhanden -> weiterhin Platzhalter.
export const images = {
  hero: "/images/exterior-front.webp",
  exterior: "/images/exterior-front.webp",
  hallway: "/images/hallway-long.webp",
  hallwayPortrait: "/images/hallway-portrait.webp",
  entry: "/images/entry-console.webp",
  entryTowels: "/images/entry-towels.webp",
  // Echte Zimmerfotos je Zimmergröße:
  roomReal: "/images/room-5bett.webp",
  room5: "/images/room-5bett.webp",
  room4: "/images/room-4bett.webp",
  room3: "/images/room-3bett.webp",
  room2: "/images/room-2bett.webp",
  roomSpacious: "/images/room-spacious.webp",
  kitchen: "/images/kitchen.webp",
  // Platzhalter – Kundenfoto folgt:
  bathroom: "https://images.pexels.com/photos/27359993/pexels-photo-27359993.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
